import angular from 'angular';
import expenseReviewComponent from './expense-review.component';

let expenseReviewModule = angular
  .module('expenseReview', ['chart.js', 'ui.bootstrap'])

  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';
  })

  .component('expenseReview', expenseReviewComponent);

export default expenseReviewModule;



// WEBPACK FOOTER //
// ./client/pages/admin/expense-review/expense-review.js